import { Fragment } from "react";
import { ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import type { InsightsController } from "../../../api/src/insights/insights.controller";
import type { UnpackResponse } from "../../../api/src/lib";
import Loading from "../Loading";
import InsightFailed from "./InsightFailed";
import { useAuthenticatedQuery } from "../lib/api";
import { securityPath } from "../lib/security";

type NewSecuritiesInsight = UnpackResponse<
  InsightsController["newSecurities"]
>["data"];

function useQueryNewSecuritiesInsight() {
  return useAuthenticatedQuery<
    UnpackResponse<InsightsController["newSecurities"]>,
    NewSecuritiesInsight,
    [string, string]
  >({
    queryKey: ["insights", "new-securities"],
    queryFn: async (newSecurities) => newSecurities.data,
  });
}

const NewSecurities = () => {
  const { isPending: isPendingNewSecurities, data: dataNewSecurities } =
    useQueryNewSecuritiesInsight();

  return isPendingNewSecurities ? (
    <ListGroupItem>
      <Loading />
    </ListGroupItem>
  ) : typeof dataNewSecurities === "undefined" ? (
    <InsightFailed />
  ) : (
    <ListGroupItem>
      You have {dataNewSecurities.count} new{" "}
      {dataNewSecurities.count === 1 ? "security" : "securities"} in client
      holdings that were not held previously
      {dataNewSecurities.symbols.length > 0 ? (
        <>
          :{" "}
          {dataNewSecurities.symbols.map((symbol, index) => (
            <Fragment key={symbol}>
              {index > 0 && ", "}
              <Link to={securityPath(symbol)}>{symbol}</Link>
            </Fragment>
          ))}
        </>
      ) : null}
      .
    </ListGroupItem>
  );
};

export default NewSecurities;
